import React from 'react';
import { Box, BoxProps } from '../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';
import { ColumnWidths } from '../../DocumentVault.meta';

export const EntityLoading: React.FC<BoxProps> = props => {
  return (
    <Box display="flex" {...props} px="12" py="16" borderColor="neutral.200">
      <Box flex={ColumnWidths.Name}>
        <Shimmer width={360} height={20} />
      </Box>

      <Box flex={ColumnWidths.LastModified}>
        <Shimmer width={100} height={20} />
      </Box>

      <Box flex={ColumnWidths.FileSize}>
        <Shimmer width={80} height={20} />
      </Box>

      <Box flex={ColumnWidths.Actions}>
        <Shimmer width={30} height={20} />
      </Box>
    </Box>
  );
};
